export enum NotificationPosition {
  HEADER = 'header',
  TOPRIGHT = 'top-right',
}
